module.exports = __webpack_public_path__ + "img/m5.47ed51fd.jpg";